import React from 'react';
import './App.css';
import "./index.css";
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutPage from './components/About';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';


function App() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <AboutPage />
      <ServicesSection />
      <TestimonialsSection />
      <Footer />
    
    </>
  );
}

export default App;


